// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__374ay","title":"AfterFrontImage_title__2muZM"};